<img
  alt=""
  fetchPriority="high"
  loading="eager"
  #imageElement
  [class]="[styleSizeImage[size], !loadImage ? 'display-none' : 'display-block']"
  [src]="setImage(srcImage)"
  [style.object-fit]="objectFitDefault ? objectFitDefault : objectFit"
  (click)="handleClick()"
  (error)="errorImage()"
  (load)="loadImage = true" />
<atm-skeleton *ngIf="!loadImage" [theme]="getSizeSkeleton()"></atm-skeleton>
